/*
 * @Description: 
 * @Author: hecai
 * @Date: 2022-11-24 18:37:37
 * @LastEditTime: 2025-07-23 17:07:09
 * @FilePath: \eye-gazer\src\Component\CameraComponent.jsx
 */
import {loadModel,processFace, setModelCallbacks} from '../utils/onnx_model.js';
import React, { useRef, useEffect, useState } from 'react';
import * as faceLandmarksDetection from '@tensorflow-models/face-landmarks-detection';

const CameraComponent = (props ) => {
  const cameraVideoRef = useRef(null);
  const cameraCanvasRef = useRef(null);
  const initModleRef = useRef(false);
  const [labelMsg, setLableMsg] = useState('')
  const isProcessing = useRef(false);
  var detector;
  async function initModle() {
    console.log('initModle');
    
    // 通知父组件模型开始加载
    if (props.onModelLoadStart) {
      props.onModelLoadStart();
    }
    
    const model = faceLandmarksDetection.SupportedModels.MediaPipeFaceMesh;
    const detectorConfig = {
      runtime: 'mediapipe', // or 'tfjs'
      refineLandmarks: true,
      // solutionPath: 'https://cdn.jsdelivr.net/npm/@mediapipe/face_mesh',
      solutionPath: '/face_mesh',
    }
    detector = await faceLandmarksDetection.createDetector(model, detectorConfig);
    console.log('initModle finish');
    openMedia();
    await loadModel();
  }
  function drawDot(ctx, x, y, dotRadius, dotColor) {
    ctx.beginPath();
    ctx.arc(x, y, dotRadius, 0, 2 * Math.PI, false);
    ctx.fillStyle = dotColor;
    ctx.fill();
  }
  function drawRect(ctx, x, y, width, height)
  {
    ctx.strokeStyle="#0000ff";
    ctx.strokeRect(x, y, width, height);
  }

  //画出面部的点位，同时做镜像处理
  function drawFace(faces) {
    const ctx = cameraCanvasRef.current.getContext('2d');
    ctx.clearRect(0, 0, cameraCanvasRef.current.width, cameraCanvasRef.current.height);
    var left = [0, 0, 0];
    var right = [0, 0, 0];
    // console.log(faces[0].keypoints)
    
    if (faces.length > 0) {
      
      
      for (const v of faces[0].keypoints) {
        v.x = props.width - v.x;
        if ("name" in v) {
          // if (v.name === 'leftIris') {
          //   left[0] = left[0] + v.x;
          //   left[1] = left[1] + v.y;
          //   left[2] = left[2] + 1;
          // } else if (v.name === 'rightIris') {
          //   right[0] = right[0] + v.x;
          //   right[1] = right[1] + v.y;
          //   right[2] = right[2] + 1;
          // }
          if (v.name === 'rightEye' || v.name === 'leftEye')

            drawDot(ctx, v.x, v.y, 1, "green");
        } else
          drawDot(ctx, v.x, v.y, 1, "blue");
      }
      drawDot(ctx,faces[0].keypoints[471].x,faces[0].keypoints[471].y, 1, "red")
      drawDot(ctx, left[0]/left[2], left[1]/left[2], 5, "red");
      drawDot(ctx, right[0] / right[2], right[1] / right[2], 5, "red");
      
      faces[0].box.xMin = props.width - faces[0].box.xMax;
      faces[0].box.xMax = faces[0].box.xMin + faces[0].box.width;
      drawRect(ctx,faces[0].box.xMin, faces[0].box.yMin, faces[0].box.width, faces[0].box.height);
    }
  }

  function checkFaceState(faces) {
    if (faces.length > 0) {
      let midX = (faces[0].box.xMin + faces[0].box.xMax) / 2
      let midY = (faces[0].box.yMin + faces[0].box.yMax) / 2
      let width = faces[0].box.width

      if (width < props.width * 0.25) {
        setLableMsg('距離太遠')
      }
      else if (width > props.width * 0.39) {
        setLableMsg('距離太近')
      }
      else if (midX > props.width * 0.6) {
        setLableMsg('請將頭部向右挪動')
      } else if (midX < props.width * 0.4) {
        setLableMsg('請將頭部向左挪動')
      }
      else if (midY > props.height * 0.75) {
        setLableMsg('請將頭部向上挪動')
      }
      else if (midY < props.height * 0.3)
        setLableMsg('請將頭部向下挪動')
      else {
        setLableMsg('')
        return true
      }
    }else   
      setLableMsg('沒有人臉')
    return false
  }
  
  // 从视频中提取人脸区域的图像数据
  function extractFaceImageData(video, faceBox) {
    // 创建一个临时canvas来提取人脸区域
    const tempCanvas = document.createElement('canvas');
    const tempCtx = tempCanvas.getContext('2d');
    
    // 设置canvas尺寸为224x224（模型需要的输入尺寸）
    tempCanvas.width = 224;
    tempCanvas.height = 224;
    
    // 计算人脸区域，添加一些边距
    const margin = 0.1; // 10% 边距
    const expandedWidth = faceBox.width * (1 + margin * 2);
    const expandedHeight = faceBox.height * (1 + margin * 2);
    const expandedX = Math.max(0, faceBox.xMin - faceBox.width * margin);
    const expandedY = Math.max(0, faceBox.yMin - faceBox.height * margin);
    
    // 将人脸区域绘制到224x224的canvas上
    tempCtx.drawImage(
      video,
      expandedX, expandedY, expandedWidth, expandedHeight,
      0, 0, 224, 224
    );
    
    // 获取图像数据
    return tempCtx.getImageData(0, 0, 224, 224);
  }
  
  async function getFace() {
    if (isProcessing.current)
      return;
    isProcessing.current = true;
    const faces = await detector.estimateFaces(cameraVideoRef.current, { flipHorizontal: false });
    if(props.drawFace)
      drawFace(faces);
    let yaw = 0;
    let pitch = 0;
    // 检查人脸状态
    const faceStateOk = checkFaceState(faces);
    
    // // 如果检测到人脸且状态正常，进行凝视估计
    if (faces.length > 0 && faceStateOk) {
      try {
        // 提取人脸区域图像数据
        const faceImageData = extractFaceImageData(cameraVideoRef.current, faces[0].box);
        
        // 调用模型处理人脸区域
        const result = await processFace(faceImageData);
        if (result) {
          yaw = result.yaw;
          pitch = result.pitch;
        }
      } catch (error) {
        console.error('凝视估计处理失败:', error);
      }
    }
    
    isProcessing.current = false;
    props.getFaceFun(faces, faceStateOk,yaw, pitch);
  }
  function successFunc(mediaStream) {
    const video = cameraVideoRef.current;
    // const video = document.getElementById('cameraVideo') as HTMLVideoElement;
    // 旧的浏览器可能没有srcObject
    if ('srcObject' in video) {
      video.srcObject = mediaStream;
    }
    console.log('open Camera success');
    video.onloadedmetadata = () => {
      video.play();
      window.setInterval(() => {
        getFace();
      }, 100);
    };
  }


  function errorFunc(err) {
    console.log(`${err.name}: ${err.message}`);
    // always check for errors at the end.
  }
  // 启动摄像头
  const openMedia = () => { // 打开摄像头
    console.log("open Camera");
    const opt = {
      audio: false,
      video: {
        width: props.width,
        height: props.height
      }
    };
    navigator.mediaDevices.getUserMedia(opt).then(successFunc).catch(errorFunc);
  };
  // 关闭摄像头
  // const closeMedia = () => {
  //   // const video = document.getElementById('cameraVideo') as HTMLVideoElement;
  //   const video = cameraVideoRef.current;
  //   const stream = video.srcObject;
  //   if ('getTracks' in stream) {
  //     const tracks = stream.getTracks();
  //     tracks.forEach(track => {
  //       track.stop();
  //     });
  //   }
  // };

  useEffect(() => {
    // 相当于 componentDidMount
    if (!initModleRef.current) {
      initModle();
      initModleRef.current = true;
    }
    return () => {
      //closeMedia();
      // 相当于 componentWillUnmount
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div style={{
      position: 'absolute',
      top: 0,
      width: props.width + 'px',
      height: (props.height+10) + 'px',
      left: '50%',
      transform: 'translate(-50%,0)',
      zIndex: 1100,
      opacity: props.opacity
    }}>
      <video
        id="cameraVideo"
        ref={cameraVideoRef}
        style={{
          width: props.width + 'px', height: props.height + 'px',
          transform: 'rotateY(180deg)',
          display: 'block',
          position: 'absolute',
          top: 0,
          left: 0,
        }}
      />
      <canvas
        id="cameraCanvas"
        ref={cameraCanvasRef}
        width={props.width}
        height={props.height}
        style={{
          width: props.width+'px', height: props.height+'px',
          position: 'absolute',
          top: 0,
          left: 0,
          zIndex: 1002, // 设置比校准界面更高的层级
        }}
      />
      <div style={{
        width: props.width+'px', height: props.height+'px',
        position: 'absolute',
        top: 0,
        left: 0,
        opacity: 0.5,
      }}>
        <img src={(process.env.PUBLIC_URL+'/res/FaceMask.png')} width={props.width + 'px'} height={props.height + 'px'}  alt="" />
      </div>
      
      <label style={{
        color: 'black',
        fontSize: '28px',
        position: 'absolute',
        bottom: '5%',
        left: '50%',
        transform: 'translate(-50%,0)',
        zIndex: 1003, // 设置比校准界面更高的层级
      }}>{labelMsg}</label>
    </div>
  )
}

export default CameraComponent;
